import React from 'react';
import styled from 'styled-components';
import { Button as MuiButton, ButtonProps } from '@material-ui/core';

const Button = styled(MuiButton)`
  &.MuiButton-root {
    text-transform: inherit;
    font-size: 1.4rem;
    font-weight: 600;
    color: var(--white);
    min-width: 88px;
    height: 32px;
    background: var(--orange);
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.25);

    &:hover {
      background: var(--orangeHover);
    }
    &.Mui-disabled {
      background: var(--grayLv6);
      color: var(--grayLv4);
    }
  }
`;

interface ButtonSubmitProps extends ButtonProps {
  children: React.ReactNode;
}

export default function ButtonSubmit({ children, ...rest }: ButtonSubmitProps) {
  return (
    <Button {...rest}>{children}</Button>
  )
}
